import React from "react";

const IconSearch = ({
  width = "20",
  height = "20",
  fill = "#000000",
 className = "",
}) => {
  return (
    <svg
      viewBox="6 6 20 20"
      className={className ? className : null}
      width={width}
      height={height}
      data-name="iconSearch"
    >
      <path
        fill={fill}
        d="M19.724 18.207h-0.799l-0.283-0.273c0.991-1.153 1.588-2.65 1.588-4.279 0-3.631-2.943-6.575-6.575-6.575s-6.575 2.943-6.575 6.575c0 3.631 2.943 6.575 6.575 6.575 1.629 0 3.126-0.597 4.279-1.588l0.273 0.283v0.799l5.057 5.047 1.507-1.507-5.047-5.057zM13.655 18.207c-2.519 0-4.552-2.033-4.552-4.552s2.033-4.552 4.552-4.552c2.519 0 4.552 2.033 4.552 4.552s-2.033 4.552-4.552 4.552v0z"
      />
    </svg>
  );
};

export default IconSearch;
